import React, { useEffect } from 'react';
import Shared from 'screens/shared';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { useSelector } from 'react-redux';
import CreateForm from './create';
import DirectionArrow from './direction-arrow';
import Action from './action';

export default ({ dcId, serverId, nicId }) => {
  const { [ACTIONS_TYPES.NIC.FLOWLOG_GET_ALL]: flowlogs = [] } = useSelector((e) => e);

  const deleteHandler = ({ id: flowlogId }) => {
    actions.nic.flowlogDelete({
      flowlogId, dcId, nicId, serverId,
    });
  };

  useEffect(() => {
    actions.nic.flowlogGetAll({ dcId, nicId, serverId });
  }, [dcId, nicId, serverId]);

  return (
    <Shared.widgets.Section
      sectionTitle="Flowlog"
      items={flowlogs}
      itemIcon="exchange-alt"
      setItemTitle={(e) => e?.properties?.name}
      setItemDetails={(e) => (
        <>
          <span>{`Bucket: ${e?.properties?.bucket}`}</span>
          <Action type={e?.properties?.action} className="m-l-15" />
          <DirectionArrow type={e?.properties?.direction} className="m-l-15" />
        </>
      )}
      itemOnDelete={deleteHandler}
      createForm={<CreateForm {...{ dcId, nicId, serverId }} />}
      createActionType={ACTIONS_TYPES.NIC.FLOWLOG_ADD}
      className="-m-t-24"
      isDeletePassword
    />
  );
};
